var server
if (window.location.hostname === 'localhost' || window.location.hostname === '0.0.0.0') {
  server = `http://${window.location.hostname}:3004/api`
} else {
  if (window.location.protocol !== 'https:') window.location = 'https://dashboard.trawlingweb.com'
  server = `https://${window.location.host}/api`
}

export default {
  server,
  key: '',
  userid: '',
  admin: false,
  user_type: 0,
  consumers: [{ description: '', token: '', counter: 0, product: 0 }],
  shop_product: 0,
  seebanner: false,
  color: {
    digital: '#80d484',
    DIGITAL: '#80d484',
    newspro: '#476b63',
    NEWSPRO: '#476b63',
    youtube: '#e62117',
    YOUTUBE: '#e62117',
    instagram: '#ca41e2',
    INSTAGRAM: '#ca41e2',
    facebook: '#4267b2',
    FACEBOOK: '#4267b2',
    twitter: '#08f5fd',
    TWITTER: '#08f5fd',
    law: '#e4d341',
    LAW: '#e4d341'
  },
  color_low: {
    digital: '#daf2db',
    DIGITAL: '#daf2db',
    newspro: '#9edcce',
    NEWSPRO: '#9edcce',
    youtube: '#fcc9c5',
    YOUTUBE: '#fcc9c5',
    instagram: '#f7daf3',
    INSTAGRAM: '#f7daf3',
    facebook: '#AEC9FF',
    FACEBOOK: '#AEC9FF',
    twitter: '#C9FBFD',
    TWITTER: '#C9FBFD',
    law: '#efe69d',
    LAW: '#efe69d'
  },
  shop_ondemand: {
    requests: 0,
    price: 0,
    type: 'digital',
    article: 'request'
  }
}
